// For more information about this file see https://dove.feathersjs.com/guides/cli/client.html
import { feathers } from '@feathersjs/feathers'
import type { TransportConnection, Application } from '@feathersjs/feathers'
import authenticationClient from '@feathersjs/authentication-client'
import type { AuthenticationClientOptions } from '@feathersjs/authentication-client'

import { settingsClient } from './services/settings/settings.shared'
export type { Settings, SettingsData, SettingsQuery, SettingsPatch } from './services/settings/settings.shared'

import { mailClient } from './services/mail/mail.shared'
export type { Mail, MailData, MailQuery } from './services/mail/mail.shared'

import { webEmailSubmissionClient } from './services/web-email-submission/web-email-submission.shared'
export type {
  WebEmailSubmission,
  WebEmailSubmissionData,
  WebImageAttachment,
  WebEmailSubmissionQuery
} from './services/web-email-submission/web-email-submission.shared'

import { telegramClient } from './services/telegram/telegram.shared'
export type { Telegram, TelegramData, TelegramQuery, TelegramPatch } from './services/telegram/telegram.shared'

export interface Configuration {
  connection: TransportConnection<ServiceTypes>
}

export interface ServiceTypes {}

export type ClientApplication = Application<ServiceTypes, Configuration>

/**
 * Returns a typed client for the SoFT app.
 *
 * @param connection The REST or Socket.io Feathers client connection
 * @param authenticationOptions Additional settings for the authentication client
 * @see https://dove.feathersjs.com/api/client.html
 * @returns The Feathers client application
 */
export const createClient = <Configuration = any>(
  connection: TransportConnection<ServiceTypes>,
  authenticationOptions: Partial<AuthenticationClientOptions> = {}
) => {
  const client: ClientApplication = feathers()

  client.configure(connection)
  client.configure(authenticationClient(authenticationOptions))
  client.set('connection', connection)

  client.configure(telegramClient)
  client.configure(webEmailSubmissionClient)
  client.configure(mailClient)
  client.configure(settingsClient)
  return client
}
